import app from "firebase/app";
import "firebase/auth";
import "firebase/database";
import moment from "moment";
const axios = require("axios").default;

const config = {
  apiKey: "AIzaSyBu-6c6UQHjtsMa_OFLligW4MZqJz2_3r4",
  authDomain: "reanibex-training.firebaseapp.com",
  databaseURL: "https://reanibex-training-fc2ad.europe-west1.firebasedatabase.app/", // "https://reanibex-training.firebaseio.com/"
  projectId: "reanibex-training",
  storageBucket: "reanibex-training.appspot.com",
  messagingSenderId: "278605445691",
  appId: "1:278605445691:web:d38ef5b04c9a111d267a1e",
  measurementId: "G-WXGCBKEFG5",
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
    this.db = app.database();
  }

  // *** Auth API ***

  doSignInWithEmailAndPassword = (email, password) => this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  // *** User API ***

  currentUser = () => this.auth.currentUser;

  setUserLang = (lang) => this.user(this.currentUser().uid).child("info").update({ defaultLang: lang });

  signInWithToken = (token) => this.auth.signInWithCustomToken(token);

  user = (uid) => this.db.ref(`users/${uid}`);

  users = () => this.db.ref("users");

  userCompletInfo = (uid) => {
    return new Promise((resolve, reject) => {
      this.user(uid)
        .once("value")
        .then((snap) => {
          let userData = { userInfo: snap.val() };
          this.userReport(uid)
            .once("value")
            .then((r) => {
              userData.reports = r.val();
              resolve(userData);
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  signUpUser = (email, password) => this.auth.createUserWithEmailAndPassword(email, password);

  userReport = (uid) => this.db.ref(`userReports/${uid}`);

  userReportLog = (uid) => this.db.ref(`userReportsLog/${uid}`);

  usersReportLog = () => this.db.ref(`userReportsLog`);

  reports = () => this.db.ref("userReports/");

  managerUsers = (mUid) => this.db.ref(`managers/${mUid}/workers`);

  managerData = (mUid) => this.db.ref(`managers/${mUid}`);

  becomeRescuer = (isRescuer) => this.db.ref(`users/${this.auth.currentUser.uid}/sgpfc`).update({ rescuer: isRescuer });

  cancelActiveRescuerView = () => this.db.ref(`users/${this.auth.currentUser.uid}/sgpfc`).update({ justPassed: false });

  verifyPasswordResetCode = (code) => this.auth.verifyPasswordResetCode(code);

  sendPasswordEmail = (email) => this.auth.sendPasswordResetEmail(email);

  udpateUSerData = (uid) => this.db.ref(`users/${uid}/info`);

  confirmPasswordReset = (code, password) => this.auth.confirmPasswordReset(code, password);

  setUsertToremove = (uid) => this.db.ref(`UsersToRemove`).push({ uid: uid, time: moment().format("LLL") });

  // *** Courses API ***

  courses = () => this.db.ref("courses");

  course = (courseId) => this.db.ref(`courses/${courseId}/`);

  // *** Course Item API ***

  coursesItem = (id) => this.db.ref(`courseItems/${id}`);

  coursesItems = () => this.db.ref(`courseItems`);

  // *** Evaluation API ***

  evaluations = () => this.db.ref("tests");

  evaluationMetadata = (uid, evaluationId) => this.userReport(uid).child(`tests/${evaluationId}/metadata`);

  evaluationTest = (evaluationID) => this.db.ref(`tests/${evaluationID}/items`).orderByKey();

  getTestItems = () => this.db.ref(`/testItems`);

  testItem = (itemID) => this.db.ref(`testItems/${itemID}`);

  evaluationAttemp = (uid, evaluationId, attemp) => this.userReport(uid).child(`tests/${evaluationId}/attemps/attemp${attemp}`);

  // *** Rescuer API ***
  checkRescuer = () => {
    this.userReport(this.auth.currentUser.uid)
      .once("value")
      .then((reports) => {
        try {
          let isRescuer = false;
          var r = reports.val().tests;
          let t1 = r?.ECS1?.metadata?.evalApproved;
          let t2 = r?.ECS2?.metadata?.evalApproved;
          let t3 = r?.ECS3?.metadata?.evalApproved;
          isRescuer = [t1, t2, t3].every((i) => i == true);
          this.becomeRescuer(isRescuer);
        } catch (error) {
          this.db.ref(`usersLog/${this.auth.currentUser.uid}`).push({ msg: error, time: moment().valueOf() });
        }
      });
  };

  // *** Alerts API ***

  alertRef = () => this.db.ref("ReanibexAlert_alerts");
  alertLogRef = () => this.db.ref("ReanibexAlert_alertsLog");
  deviceAlertLogRef = (deviceId) => this.db.ref(`ReanibexAlert_alertsLog/${deviceId}`);

  // *** FORMS API

  rescuersFormsRef = (id) => this.db.ref(`RescuersForms/${id}`);

  refreshmentFormsRef = (id) => this.db.ref(`RescuersForms/${id}/refreshmentGroups`);

  userOnsiteTrainingRef = (id) => this.db.ref(`users/${this.auth.currentUser.uid}/sgpfc/onSiteTrainings/forms/${id}`);

  /* RDN USERS */
  RDNUsersFormsRef = (id) => this.db.ref(`RDNUsersForm/${id}`);

  /* Report API */

  sendReport = (info) => {
    return this.db.ref(`Reportes/${this.auth.currentUser.uid}`).push({
      ...info,
    });
  };

  /* comunication test API */

  getComunicationsSetUps = () => this.db.ref("testDeComunicaciones/setUp").once("value");
  getComunictionTestData = (key) => this.db.ref(`testDeComunicaciones/responses/${key}`);
  getAvailablePrograms = () => this.db.ref("RDNPrograms");
}

export default Firebase;
